import styled from 'styled-components'
import { Link } from 'react-router-dom'
import miniIcon from '../../assets/images/16@2x.webp'

export const ListNews = styled.ul`
    list-style: none;
    margin-top: 18px;

`

export const NewsItem = styled.li`
    @media screen and (max-width: 767px) {
        display: flex;
    }
`

export const NewsImageLink = styled(Link)`
    display: block;
    text-decoration: none;
    box-shadow: 0 0 2px rgba(0,0,0,0.6);

    @media screen and (max-width: 767px) {
        margin-right: 10px;
    }
`

export const NewsImage = styled.img`
    width: 100%;
    height: ${({small}) => small ? '128px':'147px'};

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        height: 106px;
    }

    @media screen and (max-width: 767px) {
        width: 165px;
        height: 103px;
    }

    @media screen and (max-width: 374px) {
        width: 128px;
        height: 80px;
    }
`
export const NewsTitle = styled(Link)`
    text-decoration: none;
    margin: 6px 0 4px;
    color: #222;
    font-size: 15px;
    font-weight: bold;
    display: block;

    @media screen and (max-width: 767px) {
        font-weight: 500;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        display: -webkit-box;
    }

    @media screen and (max-width: 374px) {
        margin-top: 0;
    }
`
export const NewsCategory = styled(Link)`
    color: #222;
    font-size: 10px;
    text-transform: uppercase;
    opacity: .8;
    display: inline-block;
    text-decoration: none;
`

export const ViewMore = styled(Link)`
    color: #1c1c1a;
    font-size: 12px;
    text-decoration: none;

    &:after{
        content: "";
        background-image: url(${miniIcon});
        display: block;
        background-repeat: no-repeat;
        background-size: 16px auto;
        background-position: 1px -482px;
        width: 13px;
        height: 11px;
        display: inline-block;
    }
`
export const Box = styled.div`
    background-color: #d8d8d8;
    padding: ${({small}) => small ? '10px 12px':'16px 23px'};
    margin: ${({small}) => small ? '16px 0 0': '16px -23px 0'};

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        margin: 16px 0 0;
    }

    @media screen and (max-width: 767px) {
        margin: 12px -12px;
        padding: 12px;
    }
`

export const NewsFlex = styled.div`
    display: flex;
    flex-direction: column;
`